import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	sbDatePickerRangeContainer: {
		textAlign: "right",
		height: "100%",
	},
}));
